import {
    StillingForloebOverviewResponseModel
} from "../../../services/api/forloeb/laegeinstitutionWithStillingerResponseModel";
import {LaegeStillingModel} from "./laegeStillingModel";
import {ForloebKladdeModel} from "./forloebKladdeModel";

export class StillingForloebOverviewModel {

    public static FromResponseModel(responseModel: StillingForloebOverviewResponseModel): StillingForloebOverviewModel {
        const model = new StillingForloebOverviewModel();
        model.stillingId = responseModel.stillingId;
        model.stillingNummer = responseModel.stillingNummer;
        model.aktiv = responseModel.aktiv ?? true;
        model.laegeStillinger = responseModel.laegerStillinger.map(l => LaegeStillingModel.FromResponseModel(l));
        model.forloebKladder = responseModel.forloebKladder?.map(l => ForloebKladdeModel.FromResponseModel(l));
        return model;
    }

    stillingId: string;
    stillingNummer: string;
    aktiv: boolean;
    laegeStillinger: LaegeStillingModel[];
    forloebKladder: ForloebKladdeModel[];
}
